var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubirContratoPrestacionServicio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fdf073;}.cls-2{fill:#9a725f;}.cls-3{fill:#fff;}.cls-4{fill:#ccc;}.cls-5{fill:#603813;}.cls-6{fill:#faf49e;}.cls-7{fill:#c65550;}.cls-8{fill:#5172a1;}.cls-9{fill:#c3a998;}.cls-10{fill:#333;}.cls-11{fill:#7ac943;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.5,
    cy: 72.5,
    r: 72.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.08,77.56H85.78L81.31,88H60.45L56,77.56H27.68L41.09,25.42h59.58l13.41,52.14v34.26H27.68V77.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "97.96 108.8 42.96 108.8 42.96 31.8 82.24 31.8 97.96 47.73 97.96 108.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "98.81 47.8 82.96 47.8 82.96 31.94 98.81 47.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 47.96,
    y: 36.8,
    width: 29,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 46.96,
    y: 47.8,
    width: 12,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 60.96,
    y: 47.8,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 50.78,
    cy: 59,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 50.78,
    cy: 70.89,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 50.78,
    cy: 82.78,
    r: 3.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 50.78,
    cy: 94.67,
    r: 3.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 58.96,
    y: 54.8,
    width: 12,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 58.96,
    y: 59.8,
    width: 5,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 66.96,
    y: 59.8,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 58.96,
    y: 66.8,
    width: 16,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 58.96,
    y: 78.8,
    width: 8,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 68.96,
    y: 77.8,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 58.96,
    y: 83.8,
    width: 16,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 58.96,
    y: 90.8,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 63.96,
    y: 90.8,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 58.96,
    y: 95.8,
    width: 11,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 79.96,
    y: 56.8,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 79.96,
    y: 78.8,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "93.99 57.29 92.12 55.42 86.45 61.1 80.78 55.42 78.91 57.29 84.58 62.97 78.91 68.64 80.78 70.5 86.45 64.83 92.12 70.5 93.99 68.64 88.32 62.97 93.99 57.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "86.45 88.61 82.88 85.04 84.74 83.17 86.45 84.88 92.12 79.2 93.99 81.07 86.45 88.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M85.79,77.56,81.32,88H60.46L56,77.56H27.69v34.26h86.4V77.56Zm-50.65,28.3a1.49,1.49,0,0,1-3,0v-1.49a1.49,1.49,0,0,1,3,0Zm0-7.45a1.49,1.49,0,0,1-3,0V83.51a1.49,1.49,0,0,1,3,0Zm54.25,7.06a2.33,2.33,0,0,1-2.33,2.33H54.72a2.34,2.34,0,0,1-2.33-2.33V96.13a2.33,2.33,0,0,1,2.33-2.33H87.06a2.33,2.33,0,0,1,2.33,2.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "115.79 89.51 96.24 70.28 77.01 89.83 90.81 89.72 90.81 119.58 101.99 119.58 101.99 89.62 115.79 89.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "117.32 87.27 97.76 68.04 78.53 87.59 92.34 87.48 92.34 117.34 103.51 117.34 103.51 87.38 117.32 87.27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubirContratoPrestacionServicio);
export default __webpack_public_path__ + "static/media/subir_contrato_prestacion_servicio.6fa6fdc63dd26feda664cdb1c331d10f.svg";
export { ForwardRef as ReactComponent };